export default __webpack_public_path__ + "static/media/error.fe7690ba.png";